/**
 * HeroImagesCombined.jsx
 * Created by Tim on 12/20/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { find, toNumber } from 'lodash';
import axios from 'axios';

import HeroImageLowQuality from './HeroImageLowQuality';
import HeroImageUnavailable from './HeroImageUnavailable';
import HeroImage from './HeroImage';

const propTypes = {
    type: PropTypes.string,
    id: PropTypes.string
};

const defaultProps = {};

const heroImageUnavailable = (
    <div className="rec-image-unavailable-header-wrap">
        <HeroImageUnavailable />
    </div>
);

export default class HomeImageCombined extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            heroImage: null
        };
    }

    componentWillMount() {
        this.loadMedia();
    }

    loadMedia() {
        axios.get(`/api/media/public/${this.props.type}/${this.props.id}`, {})
            .then((res) => {
                if (res && !res.data.err) {
                    if (res.data.result) {
                        const photos = res.data.result;

                        // Set the banner photo, if it exists
                        let bannerPhoto = find(photos, { is_primary: true });
                        if (bannerPhoto === undefined) {
                            bannerPhoto = null;
                        }

                        // Todo: Mike Bray - Add preview image if viewport width under 768px

                        let heroImage = null;
                        if (!bannerPhoto && photos.length > 0) {
                            bannerPhoto = photos[0];
                        }
                        if (bannerPhoto) {
                            if (bannerPhoto.width && toNumber(bannerPhoto.width) >= 1240) {
                                heroImage = (
                                    <HeroImage
                                        heroImage={{ backgroundImage: `url(${bannerPhoto.url})` }}
                                        ariaLabel={bannerPhoto.title}
                                        breadCrumbPath={[]} />
                                );
                            }
                            else {
                                heroImage = (
                                    <HeroImageLowQuality
                                        image={bannerPhoto.url}
                                        altText={bannerPhoto.title}
                                        ariaLabel={bannerPhoto.description} />
                                );
                            }
                        }
                        else {
                            heroImage = heroImageUnavailable;
                        }

                        this.setState({ heroImage });
                    }
                    else {
                        this.setState({
                            heroImage: heroImageUnavailable
                        });
                    }
                }
                else {
                    this.setState({
                        heroImage: heroImageUnavailable
                    });
                }
            })
            .catch(() => {
                this.setState({
                    heroImage: <HeroImageUnavailable />
                });
            });
    }

    render() {
        return this.state.heroImage;
    }
}

HomeImageCombined.propTypes = propTypes;
HomeImageCombined.defaultProps = defaultProps;
